import apiInstance from '../api';

export const getAllMyEditorContent = () => {
  return apiInstance().get('/user/thirdparty/content');
}

export const  deleteMyEditorContent = (deleteId) => {
    return apiInstance().delete('/channel/content/' + deleteId + '?superadmin=true')
}
